/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Md_Mermaid_LoadingInputs */

const en_md_mermaid_loading = /** @type {(inputs: Md_Mermaid_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendering diagram…`)
};

const id_md_mermaid_loading = /** @type {(inputs: Md_Mermaid_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merender diagram…`)
};

/**
* | output |
* | --- |
* | "Rendering diagram…" |
*
* @param {Md_Mermaid_LoadingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const md_mermaid_loading = /** @type {((inputs?: Md_Mermaid_LoadingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Md_Mermaid_LoadingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_md_mermaid_loading(inputs)
	return en_md_mermaid_loading(inputs)
});